import { render, staticRenderFns } from "./fab-button.vue?vue&type=template&id=1bdd8a3c&scoped=true&"
import script from "./fab-button.vue?vue&type=script&lang=js&"
export * from "./fab-button.vue?vue&type=script&lang=js&"
import style0 from "./fab-button.vue?vue&type=style&index=0&id=1bdd8a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd8a3c",
  null
  
)

export default component.exports